// import { Message } from 'element-ui'
const compareWidth = (el) => {
  // 如果没有超出宽度，即子<父 则移除tooltip
  if (el.querySelector('.ellipse-text') && el.querySelector('.ellipse-text').offsetWidth < el.parentNode.offsetWidth) {
    const copyEl = el.parentNode // 获取到目标节点的父节点
    const copySpan = el.querySelector('.ellipse-text') // 获取到目标节点的子节点，即纯粹的span标签文案
    el.parentNode.removeChild(el) // 移除带有el-tooltip组件的节点
    copyEl.appendChild(copySpan) // 将纯粹的span标签文案整体追加到目标节点的父节点
  }
}
// 禁止点击事件
const disableClick = (event) => {
  // Message.warning('暂无权限')
  event && event.stopImmediatePropagation()
}
// 判断是否只读
const compareReadOnly = (el) => {
  return
  let auth = sessionStorage.getItem('auth-all')
  if (auth) {
    auth = JSON.parse(auth)
    if (auth.includes('readOnly')) { // 判断权限中包含只读权限
      el.addEventListener('click', disableClick, true) // 图标元素禁止点击事件
      if (el.className) {
        if (el.className.includes('el-button')) { // 判断是el-button
          el.setAttribute('disabled', 'disabled')
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' is-disabled'
          }
        } else { // 非button
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' table-disabled'
          }
        }
      }
    }
  }
}

// 判断是否可编辑
const compareEdit = (el) => {
  return
  let auth = sessionStorage.getItem('auth')
  if (auth) {
    auth = JSON.parse(auth)
    if (!auth.includes('edit')) { // 判断权限中包含只读权限
      el.addEventListener('click', disableClick, true) // 图标元素禁止点击事件
      if (el.className) {
        if (el.className.includes('el-button')) { // 判断是el-button
          el.setAttribute('disabled', 'disabled')
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' is-disabled'
          }
        } else { // 非button
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' table-disabled'
          }
        }
      }
    }
  }
}

// 判断是否可添加
const compareAdd = (el) => {
  return
  let auth = sessionStorage.getItem('auth')
  if (auth) {
    auth = JSON.parse(auth)
    if (!auth.includes('add')) { // 判断权限中包含只读权限
      el.addEventListener('click', disableClick, true) // 图标元素禁止点击事件
      if (el.className) {
        if (el.className.includes('el-button')) { // 判断是el-button
          el.setAttribute('disabled', 'disabled')
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' is-disabled'
          }
        } else { // 非button
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' table-disabled'
          }
        }
      }
    }
  }
}

// 判断是否可删除
const compareDelete = (el) => {
  return
  let auth = sessionStorage.getItem('auth')
  if (auth) {
    auth = JSON.parse(auth)
    if (!auth.includes('delete')) { // 判断权限中包含只读权限
      el.addEventListener('click', disableClick, true) // 图标元素禁止点击事件
      if (el.className) {
        if (el.className.includes('el-button')) { // 判断是el-button
          el.setAttribute('disabled', 'disabled')
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' is-disabled'
          }
        } else { // 非button
          if (!el.className.includes('is-disabled')) { // 添加禁止点击样式class
            el.className += ' table-disabled'
          }
        }
      }
    }
  }
}

export default (Vue) => {
  // 注册一个全局自定义指令 `showtip`
  // 用于判断单行文字超出时使用el-tooltip, 不超出则不使用, 使用方法, 引入组件tooltip
  Vue.directive('showtip', {
    // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
    bind: (el, binding) => {
    // bind的时候无法获取到已经带有ajax数据的DOM元素，宽度为0
    },
    // 被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
    inserted: (el) => {
      compareWidth(el) // 可以获取到ajax数据的DOM元素，即真实的宽度
    },
    // 所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
    update: (el) => {
      compareWidth(el) // 可以获取到ajax数据的DOM元素，即真实的宽度
    }
  })
  // 只读属性
  // 用于根据权限判断按钮是否能操作, 若权限组中含有readOnly权限, 则除详情外的按钮需要禁止操作, 需添加v-readOnly
  Vue.directive('readOnly', {
    bind: function (el, binding, vnode) {
    },
    unbind: function (el, binding) {
    },
    inserted: (el) => {
      compareReadOnly(el)
    },
    update: (el) => {
      compareReadOnly(el)
    }
  })
  // 编辑属性
  // 用于根据权限判断按钮是否能操作, 若权限组中含有edit权限, 则除详情外的按钮需要禁止操作, 需添加v-edit
  Vue.directive('edit', {
    bind: function (el, binding, vnode) {
    },
    unbind: function (el, binding) {
    },
    inserted: (el) => {
      compareEdit(el)
    },
    update: (el) => {
      compareEdit(el)
    }
  })
  // 添加属性
  // 用于根据权限判断按钮是否能操作, 若权限组中含有add权限, 则除详情外的按钮需要禁止操作, 需添加v-add
  Vue.directive('add', {
    bind: function (el, binding, vnode) {
    },
    unbind: function (el, binding) {
    },
    inserted: (el) => {
      compareAdd(el)
    },
    update: (el) => {
      compareAdd(el)
    }
  })
  // 删除属性
  // 用于根据权限判断按钮是否能操作, 若权限组中含有add权限, 则除详情外的按钮需要禁止操作, 需添加v-delete
  Vue.directive('delete', {
    bind: function (el, binding, vnode) {
    },
    unbind: function (el, binding) {
    },
    inserted: (el) => {
      compareDelete(el)
    },
    update: (el) => {
      compareDelete(el)
    }
  })
}
